/**
 * @generated SignedSource<<1ace6d9233f6313986ea424bde6b8e5a>>
 * @relayHash 8c140cf75fba9815d6c4c166c614038f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a47c3f21f2e1bc21973165b02b13ba5d1b7f185806fb1d5783e9d6a61492f1b7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectNotificationConfigurationState = "CONFIGURED" | "DEFAULT" | "%future added value";
export type JiraProjectSortField = "CATEGORY" | "FAVOURITE" | "KEY" | "LAST_ISSUE_UPDATED_TIME" | "LEAD" | "NAME" | "RECOMMENDATION" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraProjectFilterInput = {
  keyword?: string | null;
  notificationConfigurationState?: JiraProjectNotificationConfigurationState | null;
  projectCategoryId?: string | null;
  sortBy?: JiraProjectSortInput | null;
  types?: ReadonlyArray<JiraProjectType> | null;
};
export type JiraProjectSortInput = {
  order?: SortDirection | null;
  sortBy?: JiraProjectSortField | null;
};
export type ProjectDirectoryLayoutQuery$variables = {
  cloudId: string;
  filter: JiraProjectFilterInput;
  first?: number | null;
  isAdminSettingsContext: boolean;
  isAnonymous: boolean;
  isSpaceAgentsNonAdminViewEnabled: boolean;
  last?: number | null;
};
export type ProjectDirectoryLayoutQuery$data = {
  readonly jira: {
    readonly canBrowseProjects: {
      readonly hasPermission: boolean | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EmptyView" | "Header" | "NoPermissionViews" | "ProjectDirectoryLayout" | "ProjectsList130BadPattern" | "RefinementBar">;
};
export type ProjectDirectoryLayoutQuery = {
  response: ProjectDirectoryLayoutQuery$data;
  variables: ProjectDirectoryLayoutQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider: {
    readonly get: () => boolean;
  };
});

import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';
import isAllowingEndUsersToAccessCustomTemplates_provider from '@jira/platform__graphql-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAdminSettingsContext"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSpaceAgentsNonAdminViewEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v7 = [
  {
    "kind": "Variable",
    "name": "isAnonymous",
    "variableName": "isAnonymous"
  }
],
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "alias": "canBrowseProjects",
  "args": [
    (v8/*: any*/),
    {
      "kind": "Literal",
      "name": "type",
      "value": "BROWSE_PROJECTS"
    }
  ],
  "concreteType": "JiraPermission",
  "kind": "LinkedField",
  "name": "permission",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasPermission"
    }
  ]
},
v10 = [
  (v8/*: any*/)
],
v11 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "VIEW_ISSUES"
  }
],
v12 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "kind": "ScalarField",
  "name": "key"
},
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v18 = [
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectDirectoryLayoutQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "Header"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "RefinementBar"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectsList130BadPattern"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isAdminSettingsContext",
            "variableName": "isAdminSettingsContext"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ProjectDirectoryLayout"
      },
      {
        "kind": "FragmentSpread",
        "name": "EmptyView"
      },
      {
        "kind": "FragmentSpread",
        "name": "NoPermissionViews"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ProjectDirectoryLayoutQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canCreateProject",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          },
          {
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "filter",
                "variableName": "filter"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "last",
                "variableName": "last"
              }
            ],
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "canViewIssue",
                        "args": (v11/*: any*/),
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                      },
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      (v15/*: any*/),
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "medium"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "defaultNavigationItem",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "concreteType": "JiraProjectCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lead",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          (v13/*: any*/),
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                  }
                                ],
                                "type": "AppUser"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectUrl"
                      },
                      {
                        "alias": "canViewProjectConfig",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_PROJECT_CONFIG"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v12/*: any*/),
                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                      },
                      {
                        "alias": "jiraProjectType",
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "alias": "jiraProjectName",
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "condition": "isAdminSettingsContext",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "lastUpdatedToolTipDate",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "format",
                                "value": "COMPLETE_DATETIME_FORMAT"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "lastUpdatedFormatted",
                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                          },
                          {
                            "alias": "lastUpdatedDisplayDate",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "format",
                                "value": "RELATIVE"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "lastUpdatedFormatted",
                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                          }
                        ]
                      },
                      {
                        "condition": "isSpaceAgentsNonAdminViewEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "canViewIssues",
                            "args": (v11/*: any*/),
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": "action(type:\"VIEW_ISSUES\")"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v17/*: any*/),
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHasTotal"
              }
            ]
          },
          {
            "alias": "csmJiraProjects",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "types": [
                    "CUSTOMER_SERVICE"
                  ]
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 0
              }
            ],
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": (v18/*: any*/)
          },
          {
            "alias": "canContactAdmin",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": "jira.show.contact.administrators.form"
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "kind": "ScalarField",
                "name": "value"
              },
              (v13/*: any*/)
            ]
          },
          (v9/*: any*/),
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "shouldDisplay",
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              }
            ]
          },
          {
            "condition": "isAnonymous",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "projectListRightPanelState"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "sidebarExperimentTemplates",
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "experimentKey",
                    "value": "sidebarExperiment"
                  }
                ],
                "concreteType": "JiraProjectListViewTemplateConnection",
                "kind": "LinkedField",
                "name": "projectListViewTemplates",
                "plural": false,
                "selections": (v18/*: any*/)
              },
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraProjectCategoryConnection",
                "kind": "LinkedField",
                "name": "allJiraProjectCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isAnonymous",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraProjectCategoryConnection",
                "kind": "LinkedField",
                "name": "allJiraProjectCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "concreteType": "JiraProjectCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraProjectTypeDetailsConnection",
            "kind": "LinkedField",
            "name": "allJiraProjectTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectTypeDetailsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectTypeDetails",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a47c3f21f2e1bc21973165b02b13ba5d1b7f185806fb1d5783e9d6a61492f1b7",
    "metadata": {},
    "name": "ProjectDirectoryLayoutQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
    }
  }
};
})();

(node as any).hash = "fbc4ce42649f214856cfdd533e71f5dd";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
